var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialGmailC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6971_5637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.02495 3.63714C2.10638 3.1823 2.64045 2.88436 3.07141 3.04337C3.35696 3.14902 3.56001 3.38991 3.82018 3.53994V3.55631C3.80484 4.33656 3.83974 5.11786 3.80061 5.89704C3.20255 5.44432 2.59604 5.00269 2.00274 4.54469C2.01279 4.24199 1.97947 3.93719 2.02495 3.63714Z",
    fill: "#C7201F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88214 3.06233C9.30835 2.86793 9.86992 3.15319 9.96774 3.61067C10.0264 3.91812 9.98519 4.23349 9.99683 4.54464C9.39771 5.00581 8.78749 5.45272 8.18362 5.90756C8.18045 5.12097 8.18679 4.33439 8.17992 3.54781C8.41734 3.38933 8.61987 3.17802 8.88214 3.06233Z",
    fill: "#FDBC2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82008 3.55626C4.5239 4.07132 5.21767 4.60116 5.91725 5.12255C5.97594 5.187 6.06108 5.14474 6.1166 5.09931C6.80085 4.57792 7.49462 4.06867 8.17887 3.54781C8.18574 4.33439 8.17887 5.12097 8.18257 5.90755C7.4613 6.44321 6.75009 6.9926 6.02248 7.51875H5.97647C5.24886 6.99049 4.53818 6.44216 3.81638 5.90755L3.79946 5.89487C3.83859 5.11569 3.80369 4.33439 3.81903 3.55414L3.82008 3.55626Z",
    fill: "#ED4235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00264 4.54463C2.59594 5.00264 3.20246 5.44268 3.80052 5.89698L3.81744 5.90966C3.81744 6.93819 3.81744 7.96671 3.81744 8.99524C3.38912 9.00211 2.9608 8.99947 2.53249 8.99788C2.2406 9.00686 1.99313 8.73375 2.0037 8.44585C1.99894 7.14527 2.0037 5.84468 2.0037 4.54463H2.00264Z",
    fill: "#3984F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18362 5.90755C8.78749 5.45272 9.39983 5.0058 9.99683 4.54463C9.99683 5.82584 9.99683 7.10688 9.99683 8.38774C10.0095 8.60644 9.90799 8.84099 9.70282 8.93871C9.58173 9.0095 9.43843 8.99947 9.30412 9C8.92921 8.99524 8.5543 9.00475 8.17992 8.99471C8.18573 7.96566 8.17992 6.93449 8.18309 5.90755H8.18362Z",
    fill: "#2FA959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6971_5637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGmailC);
export default __webpack_public_path__ + "static/media/social_gmail_c.f0c3eea8fa3e52df3a89e09d375c21c2.svg";
export { ForwardRef as ReactComponent };